import { IInitialState } from "./types";

export const initialState: IInitialState = {
  promocodesValidate: {
    data: null,
    loading: false,
    error: null,
  },
};
